import IGenericResult from "../interfaces/IGenericResult";
import IPayload from "../interfaces/IPayload";
import { ToQueryString } from "../utils/utils";
import api from "./api";
import { resources } from "./resources";
class InstalacaoService {
    async update(data: any) {
        return await api.put<any>(`${resources.instalacao}/Update`, data);
    }

    async getWithFilter(filters: any) {
        return await api.get<IPayload>(`${resources.instalacao}/GetWithFilter/${ToQueryString(filters)}`);
    }

    async getInstalacoes() {
        return await api.get<IGenericResult[]>(`${resources.instalacao}/GetAllInstalacoes`);
    }
}

export default new InstalacaoService();
